@import './colors.css';

/* elements */

.fullHeight {
  min-height: 75vh;
}

article a:visited {
  color: black;
}

.active > * {
  color: var(--purple);
}

/*
hr {
  border: none;
  border-bottom: 1px solid #e5e5e5;
  margin: 12px 0;
}

h1 {
  font-size: 26px;
  font-weight: 500;
  margin: 6px 0;
}

h2 {
  font-size: 22px;
  font-weight: 500;
  margin: 6px 0;
}

h3 {
  font-size: 12px;
  font-weight: 600;
  margin: 6px 0;
  text-transform: uppercase;
}
*/

/* named classes */

.pageFull {
  margin: 18px 40px 0;
  padding-bottom: 96px;
}

.pageCenter {
  margin: 18px auto 32px;
  padding: 0 40px 96px;
  max-width: 1280px;
  font-size: 14px;
}

.pageColumns {
  display: flex;
  gap: 32px;
}

@media (max-width: 1200px) {
  .pageColumns.overlay {
    flex-direction: column-reverse;
  }

  .noStack {
    flex-direction: row;
  }
}

@media (max-width: 900px) {
  .pageColumns {
    flex-direction: column-reverse;
  }

  .noStack {
    flex-direction: row;
  }
}

.button {
  padding: 6px 24px;
  text-transform: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
}

.keyButton {
  padding: 6px 24px;
  text-transform: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  background-color: var(--purple);
  color: #fff;
}

.keyButton:hover {
  background-color: rgb(62, 25, 175);
}

button.keyButton:disabled {
  background-color: #ddd;
  color: rgb(0, 0, 0, 0.4);
}

.keyButton.MuiLoadingButton-loading {
  padding-left: 40px;
}

.keyButton .MuiLoadingButton-loadingIndicatorStart {
  left: 20px;
}

.lightKeyButton {
  padding: 6px 24px;
  text-transform: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  padding: 3px 12px;
  margin-left: -12px;
  /* background-color: #f7f7f7; */
  background: none;
  color: var(--purple);
}

.lightKeyButton:hover {
  background-color: #f5f5f5;
}

.secondaryButton {
  padding: 6px 24px;
  text-transform: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  color: #000;
  background-color: #f5f5f5;
}

.secondaryButton:hover {
  background-color: #e0e0e0;
}

.secondaryButtonActive {
  background-color: #e0e0e0 !important;
}

.underLinedButton {
  padding: 2px 2px;
  font-weight: 510;
  min-width: auto;
  background-color: white;
  border: none;
  border-radius: 0;
}
.underLinedButtonActive {
  border-bottom: 1px solid black !important;
}
.underLinedButton:hover {
  background-color: white;
  border-bottom: 1px solid black;
}

.outlineKeyButton {
  padding: 6px 24px;
  text-transform: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  background-color: #fff;
  /* border: 1px solid #d8d8d8; */
  border: 1px solid #b49bff;
  /* color: #808080; */
  color: var(--purple);
  padding: 6px 12px 6px 18px;
}

.outlineKeyButton:hover {
  color: var(--purple);
  border-color: var(--purple);
  background-color: #fff;
}

.outlineButton {
  padding: 6px 24px;
  text-transform: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  background: none;
  border: 1px solid #d8d8d8;
  color: #808080;
  padding: 6px 12px 6px 18px;
}

.outlineButton:hover {
  color: #525252;
  border-color: #ababab;
  background: none;
}

.lightSecondaryButton {
  padding: 6px 24px;
  text-transform: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  background: none;
  color: #707070;
}

.lightSecondaryButton:hover {
  background-color: #f7f7f7;
}

.copyButton {
  padding: 6px 16px;
  text-transform: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  background-color: #f3f3f3;
  color: #333;
}

.copyButton svg {
  margin-left: 4px;
}

.copyButton:hover {
  background-color: #ebebeb;
}

.textEllipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1 0;
}

.formLabelDescription {
  padding-left: 27px;
  margin-top: -6px;
  font-size: 14px;
}

.inputLabel {
  color: #2f384c;
  font-size: 14px;
  margin: 4px 0 8px;
  font-weight: 500;
}

.videoPreview video {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: black;
}

.videoBackground {
  aspect-ratio: 16 / 9;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: black;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 12px;
  text-transform: uppercase;
}

.videoErrorMessage {
  background-color: rgb(255 255 255 / 20%);
  border-radius: 18px;
  padding: 6px 16px;
  margin-bottom: 8px;
  font-size: 14px;
  text-transform: none;
}

.radioGroup {
  display: flex;
  gap: 12px;
  grid-template-columns: repeat(2, 1fr);
  font-size: 14px;
}

@media (max-width: 1200px) {
  .radioGroup {
    display: grid;
  }
}

@media (max-width: 1900px) {
  .overlay .radioGroup {
    display: grid;
  }
}

.radioWrap {
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  flex: 1 1 0;
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.radioWrap .MuiFormControlLabel-root {
  padding: 0 14px;
  width: 100%;
}

.selectedRadioWrap {
  border: 1px solid var(--purple);
  background-color: #f9f9f9;
}

.videoTitle {
  font-size: 12px;
  padding: 0 16px 8px;
  text-transform: uppercase;
  font-weight: 500;
  color: #a7a7a7;
}

.videoTitle button {
  text-transform: uppercase;
  font-size: 12px;
  padding: 4px 10px;
  color: #5a00ff;
}

.videoTitle button:hover {
  background-color: #f5f5f5;
}

.breadcrumb a {
  color: #5a00ff;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

.chip {
  height: unset;
  border: 2px solid #c7b4ff;
  color: #5924fb;
  margin-top: 5px;
  font-weight: 500;
  border-radius: 20px;
  font-size: 14px;
  padding: 3px 12px;
  display: inline-flex;
  align-items: center;
  position: relative;
}

.chip button {
  position: absolute;
  right: 2px;
}

.inputIndent {
  padding-left: 15px;
  width: calc(100% - 15px);
}

.sectionIndent {
  padding-left: 27px;
  width: calc(100% - 27px);
}

.textIndentWrap {
  position: relative;
  height: 21px;
}

.menuItemIcon {
  border-radius: 5px;
  margin-right: 10px;
  flex-shrink: 0;
  width: 64px;
  height: 36px;
  align-self: flex-start;
}

.tableRowIcon {
  border-radius: 5px;
  flex-shrink: 0;
  width: 96px;
  aspect-ratio: 16 / 9;
}

.menuItemAddIcon {
  border-radius: 5px;
  margin-right: 10px;
  flex-shrink: 0;
  width: 64px;
  height: 36px;
  border: 1px solid #c8c8c8;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 16 / 9;
  box-sizing: border-box;
}

.menuItemAddIcon svg {
  width: 18px;
  color: #808080;
}

.navLink {
  line-height: 46px;
  padding: 0 16px;
  display: inline-block;
  color: #7d7d7d;
}

.activeNavLink {
  line-height: 46px;
  padding: 0 16px;
  display: inline-block;
  color: black;
  position: relative;
}

.activeNavLink::before {
  content: '';
  display: block;
  position: absolute;
  height: 0;
  left: 6px;
  right: 6px;
  bottom: 0;
  border-bottom: 2px solid;
}

.divider {
  height: 36px;
  border-right: 1px solid #e5e5e5;
  padding-left: 12px;
  margin-right: 12px;
}

.panelRow {
  display: grid;
  grid-template-columns: 1fr 2fr;
  column-gap: 10px;
  margin-bottom: 9px;
  align-items: center;
}

.panelKey {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.panelValue {
  display: flex;
  align-items: center;
  background-color: #f3f3f3;
  padding: 0 12px;
  border-radius: 8px;
  height: 32px;
  color: #333;
  /* font-weight: 500; */
  overflow: hidden;
}

.emptyPanelValue {
  background-color: #f3f3f3;
  border-radius: 8px;
  height: 32px;
  color: #333;
  box-sizing: border-box;
}

.panelButtons {
  display: flex;
  gap: 9px;
}

.panelButtons button {
  flex: 1;
  height: 32px;
  font-size: 13px;
}

.segControl {
  display: flex;
  align-items: center;
}

.seg {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  position: relative;
  min-width: unset;
  padding: 0;
  margin-left: -1px;
  color: #999999;
  font-size: 13px;
  height: 28px;
}

.seg:first-child {
  margin-left: 0;
}

.seg:hover {
  background: none;
}

.seg svg .fill {
  fill: #c6c6c6;
}

.seg svg .stroke {
  stroke-width: 1.5;
  stroke: #999999;
}

.seg::after {
  content: '';
  color: #dadada;
  border-right: 1px solid;
  height: 14px;
  position: absolute;
  right: 0;
}

.seg.active {
  background-color: white;
  box-shadow: 0 0px 4px rgba(0 0 0 / 20%);
  color: #7f40fc;
}

.seg.active .stroke {
  stroke: #7f40fc;
}

.seg.active .fill {
  fill: #7f40fc;
}

.seg.active::after {
  display: none;
}

.seg:last-child::after {
  display: none;
}

/* utility classes */

.widthFull {
  width: 100%;
}

.flex {
  display: flex;
  align-items: center;
  gap: 12px;
}

.inlineFlex {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.inlineBlock {
  display: inline-block;
}

.block {
  display: block;
}

.grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(3, 1fr);
}

.justifyCenter {
  justify-content: center;
}

.justifyEnd {
  justify-content: end;
}

.justifyStart {
  justify-content: start;
}

.alignStart {
  align-items: start;
}

.flexColumn {
  flex-direction: column;
}

.flexRow {
  flex-direction: row;
}

.f1 {
  flex: 1;
}

.fzero {
  flex: 1 1 0;
}

.m0 {
  margin: 0;
}

.mb {
  margin-bottom: 8px;
}

.mb2 {
  margin-bottom: 16px;
}

.mb3 {
  margin-bottom: 24px;
}

.mb6 {
  margin-bottom: 48px;
}

.mt {
  margin-top: 8px;
}

.mt2 {
  margin-top: 16px;
}

.mt3 {
  margin-top: 24px;
}

.mt4 {
  margin-top: 48px;
}

.mr {
  margin-right: 8px;
}

.mr2 {
  margin-right: 16px;
}

.mr3 {
  margin-right: 24px;
}

.mr4 {
  margin-right: 48px;
}

.ml {
  margin-left: 8px;
}

.ml2 {
  margin-left: 16px;
}

.ml3 {
  margin-left: 24px;
}

.ml4 {
  margin-left: 48px;
}

.p0 {
  padding: 0;
}

.p {
  padding: 8px;
}

.p2 {
  padding: 16px;
}

.p3 {
  padding: 24px;
}

.p4 {
  padding: 32px;
}

.px {
  padding-left: 8px;
  padding-right: 8px;
}

.px2 {
  padding-left: 16px;
  padding-right: 16px;
}

.rounded {
  border-radius: 8px;
}

.roundedSmall {
  border-radius: 5px;
}

.roundedLarge {
  border-radius: 14px;
}

.border {
  border: 1px solid #e4e4e4;
}

.strong {
  color: black;
  font-weight: 500;
}

.light {
  color: #6a7383;
}

.pointer {
  cursor: pointer;
}

.center {
  text-align: center;
}

.font16 {
  font-size: 16px;
}

.font14 {
  font-size: 14px;
}

.font13 {
  font-size: 13px;
}

.font12 {
  font-size: 12px;
}

.lightBG {
  background-color: #fafafa;
}

.hoverLightBG:hover {
  background-color: #fafafa;
}

.mediumBG {
  background-color: #ebebeb;
}

.slateBG {
  background-color: #8e9ba8;
}

.whiteBG {
  background-color: #fff;
}

.white {
  color: white;
}

.purple {
  color: #7f40fc;
}

.hoverPurple:hover {
  color: #7f40fc;
}

.sticky {
  position: sticky;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.hoverShadow:hover {
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);
}

.backgroundContain {
  background-size: contain;
}

.rl h3 {
  margin: 0 0 16px 0;
  white-space: nowrap;
}

.overflowHidden {
  overflow: hidden;
}

.arVideo {
  aspect-ratio: 16 / 9;
}

.shadowLarge {
  box-shadow: 0px 2px 16px rgba(0 0 0 / 6%);
}

.noTransform {
  text-transform: none;
}

.noWrap {
  white-space: nowrap;
}

.bgWhite {
  background-color: white;
}

.demoCategories {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 4px;
  gap: 4px;
  display: flex;
}

.demoCategoryButtons {
  min-width: 50px;

  @media (max-width: 600px) {
    font-size: 14px;
    min-width: 60px;
    padding: 8px 12px;
  }
}

.demoCategoryUnderlineButtons {
  height: 35px;
  min-width: unset;

  @media (max-width: 600px) {
    font-size: 13px;
    padding: 4px;
  }
}

.demoVideos {
  display: flex;
  gap: 36px;
  align-items: center;

  @media (max-width: 600px) {
    gap: 12px;
    flex-direction: column;
  }
}

.titleCase {
  text-transform: capitalize;
}
